/** System keys of the "Finalul bolii" classifier elements (stored in
 *  originalValue, see EpidemiologyClassifierKeys on the backend). */
export const DISEASE_OUTCOME_KEYS = {
  death: 'death',
  retired: 'retired'
} as const

/** The only two "Mediul de reședință" values of the 058/e and SIDA forms —
 *  fixed ids shared with the backend (EpidemiologyResidenceEnvironments). */
export const RESIDENCE_ENVIRONMENT_IDS = {
  urban: 'c122861c-a688-431f-b026-a1d44b4dfd83',
  rural: '1524e36c-9314-41c8-b473-821690d536cb'
} as const
